import { defineStore } from 'pinia'

const STORAGE_KEY = 'cm_theme'

// The dashboard is designed dark first; users can still switch to light and the
// choice is remembered.
const DEFAULT_MODE = 'dark'

function isMode(value) {
  return value === 'light' || value === 'dark'
}

export const useThemeStore = defineStore('theme', {
  state: () => ({
    mode: DEFAULT_MODE,
  }),

  getters: {
    isDark: (state) => state.mode === 'dark',
  },

  actions: {
    /** Resolve the initial theme: the saved choice, otherwise dark. */
    init() {
      const saved = localStorage.getItem(STORAGE_KEY)
      this.mode = isMode(saved) ? saved : DEFAULT_MODE
      this.apply()
    },

    set(mode) {
      this.mode = isMode(mode) ? mode : DEFAULT_MODE
      localStorage.setItem(STORAGE_KEY, this.mode)
      this.apply()
    },

    toggle() {
      this.set(this.isDark ? 'light' : 'dark')
    },

    apply() {
      if (typeof document !== 'undefined') {
        document.documentElement.setAttribute('data-bs-theme', this.mode)
      }
    },
  },
})
